import { Injectable } from '@angular/core';
import { Http, Response, ResponseContentType, RequestOptions,

  ConnectionBackend,
  Request,
  RequestOptionsArgs,
  Headers
} from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';

import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { IMyDate } from 'mydatepicker';

@Injectable()
export class LocatelliHomeService {

  constructor(private http: Http, private router: Router) {

  }

  getToday() {

    var today;
    var currentDate = new Date()
    var day = currentDate.getDate()
    var month = currentDate.getMonth() + 1
    var year = currentDate.getFullYear()

    var monthString = month + ""
    var dayString = day + ""
    if (monthString.length < 2) {
      monthString = '0' + monthString;
    }
    if (dayString.length < 2) {
      dayString = '0' + dayString;
    }

    return today = year + "-" + monthString + "-" + dayString;
  }

  getListFilter(path) {
    var queryStr;
    queryStr = environment.restBaseUrl + path
    return this.http.get(queryStr).map(
      (response: Response) => {
        let res: any = response.json();
        this.manageResponse(res)
        return res;
      }
    ).catch(
      (error: Response) => {
        let err: any = error.json();
        if (this.manageErrors(err)) {
          return Observable.throw(err.json);
        }
      }
    );
  }

  logout(path) {

    return this.http.get(path).map(
      (response: Response) => {
        let res: any = response.json();
        this.manageResponse(res)
        localStorage.clear();
        return res;
      }
    ).catch(
      (error: Response) => {
        let err: any = error.json();
        if (this.manageErrors(err)) {
          return Observable.throw(err.json);
        }
      }
    );
  }

  delete(pathUrl) {
    let queryStr = environment.restBaseUrl;
     return this.http.delete(queryStr + pathUrl)
     .map(
      (response: Response) => {
        let res: any = response.json();
        this.manageResponse(res)
        return res;
      }
    ).catch(
      (error: Response) => {
        let err: any = error.json();
        if ( this.manageErrors(err)) {
          return Observable.throw(err.json);
        }
      }
    );
  }

  manageResponse(res) {
    if (res.outcome.success === true) {

    } else {

    }
  }

  manageErrors(err): Boolean {

    if (err.outcome.code === '0005' || err.outcome.code === '0007') {
      return false;
    }
    return true;
  }

  newObject(orderData: Object, pathUrl): Observable<any> {
    return this.http.post(environment.restBaseUrl + pathUrl, orderData)
      .map((response: Response) => {
        let res: any = response.json();
        if (res.outcome.success === true) {
          // this.logger.log("Service:",res,300);
          return res;
        } else {
       //   this.logger.log("List getResult:"," FAILURE",200);
          return res;
        }

      }).catch((error: Response) => {

        let res: any = error.json();
        if (res.outcome.code === "0005" || res.outcome.code === "0007"){
          // this.sessionExpired();
        } else {
          return Observable.throw(error.json);
        }
      }
    );
  }

  edit(dataObject: Object, pathUrl): Observable<any> {

    return this.http.put(environment.restBaseUrl + pathUrl, dataObject)
    .map(
      (response: Response) => {
        let res: any = response.json();
        this.manageResponse(res)
        return res;
      }
    ).catch(
      (error: Response) => {
        let err: any = error.json();
        if (this.manageErrors(err) ) {
          return Observable.throw(err.json);
        }
      }
    );
  }





  stringToServerFormat(StringData, hour){
    var year;
    var month;
    var day;
    var finalFormat

    year = StringData.substring(6,10)
    month = StringData.substring(3,5)
    day = StringData.substring(0,2)

finalFormat = year +"-"+month +"-"+day + hour

return finalFormat;




  }


  DataToServerFormat(data, hour) {
   var date = new Date(data)

   //date = data;

    var year;
    var month;
    var day;
    var finalFormat

    year = date.getFullYear()
    month = date.getMonth() + 1
    day = date.getDate()


    if (month < 10) {
      month = "0" + month
    }

    if (day < 10) {
      day = "0" + day
          }

    finalFormat = year +"-"+month +"-"+day + hour
    console.log(finalFormat)
    return finalFormat;




  }

  fromStringToDate(StringData) {

    var year;
    var month;
    var day;

  var   date  = new Date();




    year = StringData.substring(0,4)
    month = StringData.substring(5,7)
    day = StringData.substring(8,10)

    console.log("DATO IN ARRIVO " , StringData)
    console.log(day)

    if(day <10 ){
      console.log("SONO MINORE DI 10")
      day = day.substring(1,2)
      console.log("DAY", day )
    }

    if(month <10 ){
      console.log("SONO MINORE DI 10")
      month = month.substring(1,2)
      console.log("MONTH", month )
    }

    //let model = {
    //  date: { year: year, month: month, day: day }
    //};


    
    date.setMonth(month - 1)
    date.setDate(day)
    date.setFullYear(year)
    return date;

  }

  fromStringToDataFormatted(StringData) {

    var year;
    var month;
    var day;

    year = StringData.substring(0,4)
    month = StringData.substring(5,7)
    day = StringData.substring(8,10)

    console.log("DATO IN ARRIVO " , StringData)
    console.log(day)

    if(day <10 ){
      console.log("SONO MINORE DI 10")
      day = day.substring(1,2)
      console.log("DAY", day )
    }

    if(month <10 ){
      console.log("SONO MINORE DI 10")
      month = month.substring(1,2)
      console.log("MONTH", month )
    }

    let model = {
      date: { year: year, month: month, day: day }
    };
    return model;

  }

  fromStringToTimeHourFormatted(StringData) {


    var hour;

    hour = StringData.substring(11,13)

    console.log("ORA " , hour)



    return hour;

  }

  fromStringToTimeMinFormatted(StringData) {


    var time;
    time = StringData.substring(14,16)

    console.log("min " , time)



    return time;

  }


  stringToServerFormatCheckIn(StringData){
    var year;
    var month;
    var day;
    var finalFormat

    year = StringData.substring(6,10)
    month = StringData.substring(3,5)
    day = StringData.substring(0,2)

finalFormat = year +"-"+month +"-"+day

return finalFormat;




  }


  disableReturnData(date) {
    var st = date;

var dt = new Date(st)
console.log(dt)
dt.setDate(dt.getDate() - 1)

let model: IMyDate = {
  year: dt.getFullYear(), month: dt.getMonth() + 1, day: dt.getDate()
};
console.log(model)
return model;


  }




}



// WEBPACK FOOTER //
// ./src/app/services/locatelliHome.service.ts